import script from "./QueueCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueCreate.vue?vue&type=script&setup=true&lang=js"

import "./QueueCreate.vue?vue&type=style&index=0&id=669e0191&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669e0191"]])

export default __exports__